import { ConfigProvider, Popover } from "antd";
import Comopnay from "./DropdownLayout/Comopnay";

export default function DropDown({ nav, desc, links, children }) {
  return (
    <ConfigProvider
      theme={{
        token: {
          borderRadiusLG: 0,
          borderRadiusXS: 0,
        },
      }}
    >
      <Popover
        style={{ borderRadius: 0 }}
        arrow={false}
        placement={nav === "Company" ? "bottomLeft" : "bottom"}
        content={<Comopnay links={links} nav={nav} />}
        trigger="hover"
      >
        {children} {/* Ensure children are rendered */}
      </Popover>
    </ConfigProvider>
  );
}
